import React, { useEffect } from 'react';

const GIPlanningDetailsModal = ({
  isModalOpen,
  setIsModalOpen,
  modalData,
  modalType,
  selectedStates
}) => {
  console.log('modalData', modalData);

  // Handle ESC key to close modal
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setIsModalOpen(false);
      }
    };

    if (isModalOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isModalOpen, setIsModalOpen]);

  if (!isModalOpen || !modalData) return null;

  const formatDate = (dateStr) => {
    if (modalData.viewMode === 'weekly') {
      return `Semaine ${dateStr}`;
    }

    return new Date(dateStr).toLocaleDateString('fr-FR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-600 flex-shrink-0">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            {modalType === 'campaign' && modalData.isInterventionPointView && `Point d'intervention - ${modalData.campaign}`}
            {modalType === 'campaign' && !modalData.isInterventionPointView && `Détails - ${modalData.campaign}`}
            {modalType === 'promoter' && `Timeslots - ${modalData.promoter}`}
            {modalType === 'interventionPoint' && `Détails - ${modalData.interventionPoint}`}
          </h3>
          <button
            onClick={() => setIsModalOpen(false)}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1">
          <div className="mb-4">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {formatDate(modalData.date)}
            </p>
            {selectedStates.length > 0 && (
              <div className="mt-2 flex items-center gap-2">
                <span className="text-xs text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 px-2 py-1 rounded">
                  Filtre actif : {selectedStates.join(', ')}
                </span>
              </div>
            )}
          </div>

          {modalType === 'campaign' && (
            <div>
              <h4 className="text-md font-medium text-gray-900 dark:text-white mb-3">
                {modalData.isInterventionPointView
                  ? `Campagnes et Clients (${modalData.entries.length})`
                  : `Promoteurs et Points d'intervention (${modalData.entries.length})`
                }
              </h4>
              <div className="space-y-2">
                {modalData.entries.map((entryData, index) => (
                  <div key={index} className="bg-gray-50 dark:bg-gray-700 p-3 rounded-md">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm text-gray-800 dark:text-gray-200">{entryData.entry}</span>
                      <div className="flex items-center space-x-2">
                        <span className={`text-sm font-medium ${entryData.stateColor}`}>
                          {entryData.stateIcon} {entryData.state}
                        </span>
                      </div>
                    </div>

                    {entryData?.timeslots?.length > 0 && (
                      <div className="space-y-1">
                        {entryData.timeslots
                          .sort((a, b) => a.StartTime.localeCompare(b.StartTime))
                          .map((timeslot, tIndex) => (
                            <div key={tIndex} className="text-sm text-gray-600 dark:text-gray-400">
                              {timeslot.StartTime.substring(0, 5)} - {timeslot.EndTime.substring(0, 5)}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {modalType === 'promoter' && (
            <div>
              <h4 className="text-md font-medium text-gray-900 dark:text-white mb-3">
                Créneaux horaires ({modalData.timeslots.length})
              </h4>
              <div className="space-y-2">
                {modalData.timeslots.map((timeslot, index) => (
                  <div key={index} className="bg-gray-50 dark:bg-gray-700 p-3 rounded-md flex items-center justify-between">
                    <span className="text-sm text-gray-800 dark:text-gray-200">
                      {timeslot.StartTime} - {timeslot.EndTime}
                    </span>
                    <div className="flex items-center space-x-2">
                      <span className={`text-sm font-medium ${timeslot.stateColor}`}>
                        {timeslot.stateIcon} {timeslot.state}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {modalType === 'interventionPoint' && (
            <div>
              <h4 className="text-md font-medium text-gray-900 dark:text-white mb-3">
                Promoteurs et créneaux ({modalData.promotersWithTimeslots.length})
              </h4>
              <div className="space-y-4">
                {modalData.promotersWithTimeslots.map((item, index) => (
                  <div key={index} className="bg-gray-50 dark:bg-gray-700 p-4 rounded-md">
                    <div className="flex items-center justify-between mb-2">
                      <div className="font-medium text-gray-900 dark:text-white">
                        {item.promoter}
                      </div>
                      <div className="flex items-center space-x-2">
                        <span className={`text-sm font-medium ${item.stateColor}`}>
                          {item.stateIcon} {item.state}
                        </span>
                      </div>
                    </div>
                    <div className="space-y-1">
                      {item.timeslots.map((timeslot, tIndex) => (
                        <div key={tIndex} className="text-sm text-gray-600 dark:text-gray-400 flex items-center justify-between">
                          <span>{timeslot.StartTime} - {timeslot.EndTime}</span>
                          <span className={`text-xs ${timeslot.stateColor}`}>
                            {timeslot.stateIcon}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GIPlanningDetailsModal;